import { useParams } from 'react-router-dom';

import '@VDL/assets/banner.css';

import {
  VDLBannerToolbarButtons,
  type OnClickButtonObject
} from '@VDL/components/VDLBanner/VDLToolbarButtons';
import { VDLBannerTitle } from '@VDL/components/VDLBanner/VDLBannerTitle';
import { VDLBannerBackButton } from '@VDL/components/VDLBanner/VDLBannerBackButton';
import { VDLAgreementButton } from '@VDL/components/VDLAgreementButton';

import { useVDLStore } from '@VDL/store/VDLstore';
import { SHOW_AGREEMENT } from '../../utils/consts';

export interface IBannerProps {
  title: string;
  activeButtonObjectCode: string;
  loadingButton: string;
  onClickButtonObject: OnClickButtonObject;
}

export const VDLBanner = ({
  title,
  activeButtonObjectCode,
  loadingButton,
  onClickButtonObject
}: IBannerProps) => {
  const { level0Code } = useParams();
  const { agreementData } = useVDLStore();

  const agreementObject = agreementData.find(
    (agreementItem) => agreementItem.code === level0Code
  );

  return (
    <div className="banner-bg relative space-y-3 bg-cover p-6 py-4 md:rounded-lg">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2 overflow-hidden">
          <VDLBannerBackButton />
        </div>
        {SHOW_AGREEMENT && <div className="mt-0.5">
          <VDLAgreementButton
            level0Code={level0Code}
            agreementObject={agreementObject}
          />
        </div>}
      </div>
      <VDLBannerTitle title={title} />
      <VDLBannerToolbarButtons
        activeButtonObjectCode={activeButtonObjectCode}
        onClickButtonObject={onClickButtonObject}
        loadingButton={loadingButton}
      />
    </div>
  );
};
